import DeviceDetector from "device-detector-js";





const macroReplaceFunctions = {
  'CACHE_BUSTER': () => Math.floor(Math.random() * 1_000_000_000),
  'USER_AGENT':   () => encodeURIComponent(navigator.userAgent || ''),
  'DISPLAY_HEIGHT':({playerHeight}) => String(playerHeight || 1080),
  'DISPLAY_WIDTH':({playerWidth}) => String(playerWidth || 1920),
  'LIMIT_TRACKING':() => 'false',
  'KIDS_CONTENT': () => 'false',
  'DEVICE_MODEL': () => encodeURIComponent(navigator.userAgentData?.model || ''),
  'TIMESTAMP': () => Date.now(),
  'LOCALE': () => encodeURIComponent(navigator.language || ''),
  'AUTOPLAY': ({autoplay}) => autoplay ? '1' : '0',
  'DEVICE_BRAND_NAME': () => encodeURIComponent(location.hostname || ''),
  'RHEBUS_VIDEO_SITE_URL': () => encodeURIComponent(location.href || ''),
  'CUEPOINTS': ({ adBreaks }) => {
    if (!adBreaks) return '';
    return adBreaks
      .map(time => {
        const [minutes, seconds] = time.split(':').map(Number);
        return (minutes * 60 + seconds).toString();
      })
      .join(',');
  },
  'LANGUAGE': () => encodeURIComponent(navigator.language || ''),
  'DEVICE_MAKE': () => {
    const deviceDetector = new DeviceDetector();
    const userAgent = navigator.userAgent;
    const userAgentParsed = deviceDetector.parse(userAgent);
    return encodeURIComponent(userAgentParsed.device?.brand || "Unknown")

  },
  'DEVICE_MODEL': () => {
    const deviceDetector = new DeviceDetector();
    const userAgent = navigator.userAgent;
    const userAgentParsed = deviceDetector.parse(userAgent);
    return encodeURIComponent(userAgentParsed.device?.model || "Unknown")
  },
  'DNT': () => "1",
  'MUTE': ({ mute }) => mute ? '1' : '0',
  'SKIPPABLE': ({ skip }) => skip ? '1' : '0',
};

export function replaceMacrosDynamically(adTag, playerWidth, playerHeight, autoplay, mute, skip, adBreaks) {
  if (!adTag) return ''
  return Object.keys(macroReplaceFunctions).reduce((url, macroName) => {
    const fn = macroReplaceFunctions[macroName]
    if (url.includes(macroName)) {
      const value = String(fn({ playerWidth, playerHeight, autoplay, mute, skip, adBreaks }))
      const macroRegex = new RegExp(`\\b${macroName}\\b`, 'g')
      return url.replaceAll(macroRegex, value)
    }
    return url
  }, adTag)
}
